import React from "react";
import styled from "@emotion/styled";
import IconButton from "@mui/material/IconButton";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import "./style.scss";

const ButtonsGroupContainer = styled.div`
  align-items: center !important;
  background-color: white;
  border-radius: 10px;
  color: black;
  display: flex;
  font-family: Poppins;
  font-size: 14px;
  height: 30px;
  margin: 0px 15px;
  width: 90px;
  z-index: 15;
`;

const ButtonContainer = styled.div`
  align-items: center !important;
  display: flex;
  justify-content: center !important;
  width: 30px;
`;

export default function QuantityComponent() {
  const [value, setValue] = React.useState(0);

  return (
    <ButtonsGroupContainer className="option-quantity">
      <ButtonContainer>
        <IconButton
          className="quantity-buttons"
          disableRipple
          disabled={value === 0}
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            setValue(value - 1);
          }}
        >
          <ChevronLeftIcon
            className={
              value === 0 ? "quantity-icons-disabled" : "quantity-icons"
            }
          />
        </IconButton>
      </ButtonContainer>
      <ButtonContainer>{value}</ButtonContainer>
      <ButtonContainer>
        <IconButton
          className="quantity-buttons"
          disableRipple
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            setValue(value + 1);
          }}
        >
          <ChevronRightIcon className="quantity-icons" />
        </IconButton>
      </ButtonContainer>
    </ButtonsGroupContainer>
  );
}
